<template>
  <div class="flex flex-col justify-center w-full">


    <div v-if='getPost.id' class="self-start">
      <h3 class="p-1 text-3xl truncate text-white font-semibold">{{getPost.title}}</h3>
      <h3 class="p-1 text-gray-300 -mt-4">Download</h3>

    </div>

    <div v-show='false' class="w-full flex flex-row justify-end">
      <button class="transparent-button flex flex-row" @click='showHelp = true'>
        <comment-quote :size='32' />
        <span class="text-xs ml-2">Feedback</span>
      </button>
    </div>

    <div class="mx-0 flex justify-center mb-4">
      <pbc-toggle-button :value='mode === id' @toggle='onToggleClip(id)' v-for='({id,name,clip}) in clipTypes' :key='id'  class="w-24 p-1" mode='outline'>
        <div class="flex flex-row">
          <clock v-if='!isWaiting(clip) && !isDone(clip)' />
          <check v-else-if='isDone(clip)' />
          <span class="mx-auto">{{name}}</span>
        </div>
      </pbc-toggle-button>
    </div>

    <div v-if='!getPost.id' class="h-64">
      <fill-loader />
      <p class="my-auto text-white text-lg">Loading.</p>
    </div>

    <div v-else class="flex flex-row justify-center">
      <div class="mx-0 flex mb-4 flex-col justify-start">
        <pbc-toggle-button v-model='isMovie' class="w-12 p-1 mb-4" mode='outline'>
          <movie-icon />
          <span class="text-xs">Movie</span>
          <div v-if='activeClip.status !== "recorded"' class="bg-blue-800 text-white text-xs p-1 rounded">{{activeClip.progress}}%</div>
          <div v-else class="bg-blue-800 text-white text-xs p-1 rounded">1</div>
        </pbc-toggle-button>
        <pbc-toggle-button v-model='isImage' class="w-12 p-1" mode='outline' :disabled='activeClip.screenshots.length === 0'>
          <image-outline />
          <div class="text-xs">Image</div>
          <div v-if='activeClip.screenshots.length' class="bg-blue-800 text-white text-xs p-1 rounded">{{activeClip.screenshots.length}}</div>
        </pbc-toggle-button>
      </div>


      <show-clip v-if='isMovie' class="flex flex-col" :clip='activeClip' :post-id='getPost.id' />
      <show-screenshots v-else class="flex flex-col" :clip='activeClip' :post-id='getPost.id' />
    </div>

    <portal v-if='showHelp' to="last-modal">
      <pbc-overlay @close='showHelp = false' @done='showHelp = false'>
        <div class="bg-gray-300 p-1 grow overflow-hidden flex flex-col">
          <pbc-cta-help class="overflow-y-auto grow" />
        </div>
      </pbc-overlay>
    </portal>

  </div>
</template>
<script>
import Movie from '@icons/Movie.vue';
import ImageOutline from '@icons/ImageOutline.vue'; 
import { sortBy } from 'lodash';
import Clock from '@icons/Clock.vue';
import Check from '@icons/Check.vue';
import { getPostQuery, clipAddedSubscription } from '@/gql/Queries.js';
import PbcCtaHelp from '@ui/atoms/PbcCtaHelp.vue';
import PbcToggleButton from '@ui/atoms/PbcToggleButton.vue';
import CommentQuote from '@icons/CommentQuote.vue';
import ShowClip from '@ui/atoms/ShowClip.vue';
import ShowScreenshots from '@ui/atoms/ShowScreenshots.vue';

export default {
  inject: ['api'],
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      mode:'',
      type:'movie',
      showHelp:false,
      getPost:{
        clips:[]
      }
    }
  },
  apollo: {
    getPost: {
      fetchPolicy: 'cache-and-network',
      query: getPostQuery,
      variables() {
        return {
          id:this.id
        }
      },
      subscribeToMore: {
        document: clipAddedSubscription,
        updateQuery: (previousResult, {subscriptionData:{data}}) => {
          if (!previousResult) {
            return;
          }
          const {getPost} = previousResult;
          const {addedClip} = data;

          if (getPost.id === addedClip.postId) {
            if (typeof(getPost.clips) === 'undefined') {
              getPost.clips = [];
              getPost.clips.push(addedClip)
            } else {
              let found = false;
              getPost.clips.forEach( (existingClip) => {
                if (existingClip.id === addedClip.id) {
                  Object.assign(existingClip, addedClip);
                  found = true;
                }
              });
              if (!found) {
                getPost.clips.push(addedClip);
              }
            }
          }
        }

      }

    },

  },
  mounted() {
    this.$ana.track({
      eventCategory: 'ui',
      eventAction: 'openDownload',
    });
    this.refreshInterval = setInterval( () => {
      this.refresh();
    }, 3 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.refreshInterval);
  },
  components: {
    PbcToggleButton,
    CommentQuote,
    PbcCtaHelp,
    Check,
    Clock,
    ShowClip,
    ShowScreenshots,
    MovieIcon:Movie,
    ImageOutline
  },
  methods:{
    refresh() {
      this.$apollo.queries.getPost.refetch();
    },
    onToggleClip(id) {
      this.mode = id;
    },
    isWaiting(clip) {
      return clip.status === 'waiting';
    },
    isDone(clip) {
      return clip.status === 'recorded' || (clip.mp4Url);
    },
  },
  computed:{
    clipTypes() {
      return sortBy(this.post.clips.map( (clip) => {
        const {id,aspect} = clip;
        let name = clip.name;
        if (!clip.name) {
          if (aspect === '1x1') {
            name = 'Square';
          } else if (aspect === '9x16') {
            name = 'Portrait';
          } else {
            name = aspect;
          }
        }
        return {
          id,
          aspect,
          clip,
          name
        }
      }), ({name}) => {
        return name;
      });
    },
    post() {
      return this.getPost;
    },
    activeClip() {
      const s = this.post.clips.filter( ({id}) => {
        return id === this.mode;
      });
      if (s.length) {
        return s[0];
      } else {
        return {screenshots:[]};
      }
    },
    portrait() {
      if (!this.hasPortrait) {
        return [{}];
      }
      return this.post.clips.filter( ({aspect}) => {
        return aspect === '9x16';
      })[0] || {};
    },
    square() {
      if (!this.hasSquare) {
        return [{}];
      }
      return this.post.clips.filter( ({aspect}) => {
        return aspect === '1x1';
      })[0] || {};
    },

    hasPortrait() {
      const present = this.post.clips.filter( ({aspect}) => {
        return aspect === '9x16';
      });

      return !!(present.length)
    },
    hasSquare() {
      const present = this.post.clips.filter( ({aspect}) => {
        return aspect === '1x1';
      });

      return !!(present.length)
    },

    isMovie: {
      set(nv) {
        this.type = "movie"
      },
      get() {
        return this.type === 'movie';
      }
    },
    isImage: {
      set(nv) {
        this.type = "image"
      },
      get() {
        return this.type === 'image';
      }
    }

  },
  watch:{
    type(nv) {
      this.$ana.track({
        eventCategory: 'downloadType',
        eventAction: nv
      });
    },
    'post.clips.length':{
      handler() {
        if ((!this.mode || this.mode === '') && this.post.clips && this.post.clips.length) {
          this.mode = sortBy(this.post.clips, ({name,aspect,progress,status}) => {
            if (!name) {
              if (aspect === '1x1') {
                name = 'Square';
              } else if (aspect === '9x16') {
                name = 'Portrait';
              } else {
                name = aspect;
              }
            }

            if (status === 'recorded') {
              return "-100" + name;
            } else {
              return (-progress).toString().padStart(2,'0') + name;
            }
          })[0].id;
        }
      },
      immediate:true
    }
  }
}
</script>
<style>
.clip-size-label {
  @apply text-gray-500 text-sm;
}
</style>
